import angular from 'angular';
import usersSubscription from './usersSubscription';

export default angular
  .module('components.usersSubscription', [])
  .component('usersSubscription', usersSubscription).name;
